import Cookies from "js-cookie";
import { decode } from "base-64";

/**
 * Determines the default route for a logged-in user based on their permissions and vehicle type
 * Returns the appropriate route path that the user has access to
 */
export const getDefaultRoute = () => {
  try {
    // Get user data from cookies
    const userDataCookie = Cookies.get('ispermission');
    const vehicleTypeCookie = Cookies.get('vehicletype');
    const roleCookie = Cookies.get('role');

    if (!userDataCookie || !vehicleTypeCookie || !roleCookie) {
      return '/'; // Return login page if cookies are missing
    }

    const userData = JSON.parse(userDataCookie);
    const vehicleType = decode(vehicleTypeCookie);
    const role = decode(roleCookie);
    const permissions = userData?.permissions || [];

    const is3w = vehicleType?.toLowerCase() === "3w";
    const is2w = vehicleType?.toLowerCase() === "2w";

    // Check for super admin first
    if (role?.toLowerCase() === 'super_admin') {
      return is3w ? '/3w/pgmlist' : '/pgmlist';
    }

    // 3W specific routing
    if (is3w) {
      if (permissions.includes("pgm_registration_approval")) {
        return '/3w/pgmlist';
      }
      if (permissions.includes("support_access")) {
        return '/3w/support/query';
      }
      if (permissions.includes("schedule_notifications")) {
        return '/notification';
      }
      // Default 3W route
      return '/3w/pgmlist';
    }

    // 2W specific routing - follow same priority as login redirect
    if (is2w) {
      if (permissions.includes("pgm_registration_approval")) {
        return '/pgmlist';
      }
      if (permissions.includes("schedule_notifications")) {
        return '/notification';
      }
      if (permissions.includes("incentive_mapping")) {
        return '/rewardredeem';
      }
      if (permissions.includes("view_reports")) {
        return '/reportgeneration';
      }
      if (permissions.includes("redemption_limit")) {
        return '/redemptionlimit';
      }
      if (permissions.includes("support_access")) {
        return '/query';
      }
      if (permissions.includes("can_access_msr")) {
        return '/msr';
      }
      if (permissions.includes("generate_unique_id")) {
        return '/uniqueidgenerationlist';
      }
      if (permissions.includes("can_access_dsr")) {
        return '/dsr';
      }
      if (permissions.includes("upload_beat_plan")) {
        return '/beatmanagement';
      }
      if (permissions.includes("can_access_dbt_mapping")) {
        return '/dbtrulemanagement';
      }
      if (permissions.includes("upload_pincode_master")) {
        return '/pincodemasterlist';
      }
      if (permissions.includes("target_vs_achievement")) {
        return '/planvsactual';
      }
    }

    // Fallback to login if no matching permissions
    return '/';
  } catch (error) {
    console.error('Error determining default route:', error);
    return '/'; // Return login page on error
  }
};
